import {urlParams} from 'utils/urlParams'

import {MarketingContext} from '@vio/core/src/analytics/types/Events'

const getMarketingContext = (): MarketingContext => {
  const {
    utm_source: utmSource = '',
    utm_campaign: utmCampaign = '',
    clickId
  } = urlParams()

  return {utmSource, utmCampaign, clickId, utmMedium: '', label: ''}
}

export default getMarketingContext
